export type Language = 'nl' | 'tr';

interface TranslationSection {
  [key: string]: string;
}

interface Translations {
  [key: string]: TranslationSection;
}

export const translations: Record<Language, Translations> = {
  nl: {
    urlForm: {
      label: 'Voer een URL in om te converteren naar een podcast',
      placeholder: 'https://voorbeeld.be/artikel',
      button: 'Genereer Podcast',
      generating: 'Podcast wordt gegenereerd...'
    },
    error: {
      title: 'Er is een fout opgetreden',
      apiKey: 'API sleutels zijn niet correct geconfigureerd'
    },
    audioPlayer: {
      ready: 'Je Podcast is Klaar!',
      downloadAudio: 'Download MP3',
      downloadTranscript: 'Download Transcript',
      script: 'Podcast Script'
    },
    processExplanation: {
      webAnalysis: 'Webpagina Analyse',
      webAnalysisDesc: 'De AI scant en analyseert de inhoud van de webpagina',
      aiProcessing: 'AI Verwerking',
      aiProcessingDesc: 'Geavanceerde AI technologie verwerkt de informatie',
      scriptGen: 'Script Generatie',
      scriptGenDesc: 'De AI creëert een natuurlijk klinkend gesprek',
      voiceOpt: 'Stemoptimalisatie',
      voiceOptDesc: 'De stemmen worden verfijnd voor natuurlijke interactie',
      audioSynth: 'Audio Synthese',
      audioSynthDesc: 'De tekst wordt omgezet naar hoogwaardige spraak',
      p3Tech: 'P3Media Technologie',
      p3TechDesc: 'Gebruikmakend van P3Media\'s innovatieve systemen',
      optimization: 'Optimalisatie',
      optimizationDesc: 'P3Media\'s algoritmes verfijnen de audio-output',
      qualityControl: 'Kwaliteitscontrole',
      qualityControlDesc: 'P3Media\'s AI bewaakt de audiokwaliteit',
      p3Platform: 'P3Media Platform',
      p3PlatformDesc: 'Verwerking via P3Media\'s geavanceerde infrastructuur',
      expertise: 'Expertise',
      expertiseDesc: 'Gebouwd op P3Media\'s jarenlange ervaring',
      aiAssist: 'AI Assistentie',
      aiAssistDesc: 'P3Media\'s AI assistenten verfijnen de content',
      voiceProd: 'Stemproductie',
      voiceProdDesc: 'P3Media\'s stemtechnologie in actie',
      audioExport: 'Audio Export',
      audioExportDesc: 'P3Media\'s tools maken de podcast gereed',
      finalTouch: 'Finale Touch',
      finalTouchDesc: 'P3Media\'s finishing touches worden toegepast',
      qualityGuarantee: 'Kwaliteitsgarantie',
      qualityGuaranteeDesc: 'P3Media\'s kwaliteitsstandaard gegarandeerd',
      visitP3Media: 'Bezoek P3Media\'s Website'
    },
    blogPost: {
      generate: 'Genereer SEO Blog Post',
      generating: 'Blog Post wordt gegenereerd...',
      download: 'Download als PDF',
      seoInfo: 'SEO Informatie',
      readabilityScore: 'Leesbaarheid Score',
      seoScore: 'SEO Score',
      focusKeyphrase: 'Focus Keyphrase',
      suggestedTitle: 'Voorgestelde Titel',
      suggestedSlug: 'Voorgestelde URL',
      keywords: 'Keywords'
    }
  },
  tr: {
    urlForm: {
      label: 'Podcast\'e dönüştürmek için URL girin',
      placeholder: 'https://ornek.com/makale',
      button: 'Podcast Oluştur',
      generating: 'Podcast oluşturuluyor...'
    },
    error: {
      title: 'Bir hata oluştu',
      apiKey: 'API anahtarları doğru yapılandırılmamış'
    },
    audioPlayer: {
      ready: 'Podcast\'iniz Hazır!',
      downloadAudio: 'MP3 İndir',
      downloadTranscript: 'Transkript İndir',
      script: 'Podcast Metni'
    },
    processExplanation: {
      webAnalysis: 'Web Sayfası Analizi',
      webAnalysisDesc: 'AI web sayfasının içeriğini tarar ve analiz eder',
      aiProcessing: 'AI İşleme',
      aiProcessingDesc: 'Gelişmiş AI teknolojisi bilgiyi işler',
      scriptGen: 'Metin Oluşturma',
      scriptGenDesc: 'AI doğal bir konuşma akışı oluşturur',
      voiceOpt: 'Ses Optimizasyonu',
      voiceOptDesc: 'Sesler doğal etkileşim için optimize edilir',
      audioSynth: 'Ses Sentezi',
      audioSynthDesc: 'Metin yüksek kaliteli sese dönüştürülür',
      p3Tech: 'P3Media Teknolojisi',
      p3TechDesc: 'P3Media\'nın yenilikçi sistemlerini kullanır',
      optimization: 'Optimizasyon',
      optimizationDesc: 'P3Media\'nın algoritmaları ses çıktısını iyileştirir',
      qualityControl: 'Kalite Kontrolü',
      qualityControlDesc: 'P3Media\'nın AI\'si ses kalitesini denetler',
      p3Platform: 'P3Media Platform',
      p3PlatformDesc: 'P3Media\'nın gelişmiş altyapısı üzerinde işleme',
      expertise: 'Uzmanlık',
      expertiseDesc: 'P3Media\'nın yıllara dayanan deneyimine dayanır',
      aiAssist: 'AI Asistanı',
      aiAssistDesc: 'P3Media\'nın AI asistanları içeriği iyileştirir',
      voiceProd: 'Ses Üretimi',
      voiceProdDesc: 'P3Media\'nın ses teknolojisi çalışıyor',
      audioExport: 'Ses Dışa Aktarma',
      audioExportDesc: 'P3Media\'nın araçları podcast\'i hazırlar',
      finalTouch: 'Son Rötuşlar',
      finalTouchDesc: 'P3Media\'nın son rötuşları uygulanır',
      qualityGuarantee: 'Kalite Garantisi',
      qualityGuaranteeDesc: 'P3Media\'nın kalite standardı garanti edilir',
      visitP3Media: 'P3Media\'nın Web Sitesini Ziyaret Et'
    },
    blogPost: {
      generate: 'SEO Blog Yazısı Oluştur',
      generating: 'Blog yazısı oluşturuluyor...',
      download: 'PDF olarak indir',
      seoInfo: 'SEO Bilgisi',
      readabilityScore: 'Okunabilirlik Puanı',
      seoScore: 'SEO Puanı',
      focusKeyphrase: 'Odak Anahtar Kelime',
      suggestedTitle: 'Önerilen Başlık',
      suggestedSlug: 'Önerilen URL',
      keywords: 'Anahtar Kelimeler'
    }
  }
};